
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "18px",
    "height": "10px",
    "viewBox": "0 0 18 10",
    "enable-background": "new 0 0 18 10",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "18",
        "height": "10"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "_x3C_切片_x3E__9_",
        "display": "none",
        "fill": "none",
        "width": "18",
        "height": "10"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#CCCCCC",
        "d": "M17.229,1.579H0.771C0.346,1.579,0,1.226,0,0.789C0,0.354,0.346,0,0.771,0h16.457\r\n\tC17.654,0,18,0.354,18,0.789C18,1.226,17.654,1.579,17.229,1.579z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#CCCCCC",
        "d": "M17.229,5.788H0.771C0.346,5.788,0,5.435,0,4.999S0.346,4.21,0.771,4.21h16.457\r\n\tC17.654,4.21,18,4.563,18,4.999S17.654,5.788,17.229,5.788z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#CCCCCC",
        "d": "M17.229,10H0.771C0.346,10,0,9.646,0,9.211c0-0.437,0.346-0.79,0.771-0.79h16.457\r\n\tc0.426,0,0.771,0.354,0.771,0.79C18,9.646,17.654,10,17.229,10z"
      }
    }
  ]
})
    }
  